import { Suspense, lazy, useEffect } from 'react';
import { PageLoader } from '@core-web/ui';
import { useVerifyUser } from '@apps/auth';
import { useGetFilePaths } from '@echotex/api-react';

const PublicManager = lazy(() => import('../PublicManager'));
const PrivateManager = lazy(() => import('../PrivateManager'));

export const RouterManager = () => {
  const { isAuthenticated, isLoading } = useVerifyUser();
  // const logoutUserApiHook = useLogoutUser();
  const getFilePathApiHook = useGetFilePaths();

  // lifecycle hooks
  useEffect(() => {
    // window.addEventListener('beforeunload', function (event) {
    //   logoutUserApiHook.callApi({});
    // });
    if (isAuthenticated) {
      getFilePathApiHook.callApi(null);
    }
  }, [isAuthenticated]);

  if (isLoading) {
    return <PageLoader />;
  }

  return <Suspense fallback={<PageLoader />}>{isAuthenticated ? <PrivateManager /> : <PublicManager />}</Suspense>;
};
